import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import { Admin_API, SUPRIVISOR_API } from '../../ApiNames';



export const fetchDDetails1 = (getdetails1: any) => ({
    type: 'FETCH_GET1_SUCCESS',
    payload: getdetails1,
});
export const fetchDDetails2 = (getdetails2: any) => ({
    type: 'FETCH_GET2_SUCCESS',
    payload: getdetails2,
});
export const fetchDDetails3 = (getdetails3: any) => ({
    type: 'FETCH_GET3_SUCCESS',
    payload: getdetails3,
});
export const fetchDDetails4 = (getdetails4: any) => ({
    type: 'FETCH_GET4_SUCCESS',
    payload: getdetails4,
});
export const fetchImage = (image: any) => ({
    type: 'FETCH_IMAGE_SUCCESS',
    payload: image,
});
export const viewimage = (view: any) => ({
    type: 'FETCH_VIEW_SUCCESS',
    payload: view,
});





export const fetchDocData1 = (id:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:4,aid:id,uid:uid};
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails1(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData2 = (id:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:10,aid:id,userid:uid};
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails2(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData3 = (id:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:3,aid:id,uid:uid};
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails3(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchDocData4 = (id:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:9,aid:id,uid:uid};
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchDDetails4(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = SUPRIVISOR_API.sviewdocimage;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(fetchImage(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const ViewImageData = (DocID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {q:11,docid:DocID};
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname,payload);
            dispatch(viewimage(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

